<script setup>

const props = defineProps({
  title: {
    type: String,
    default: 'Recent Activity'
  },
  items: {
    type: Array,
    default: () => []
  }
});

const iconMap = {
  alert: { path: 'M11 15h2v2h-2v-2zm0-8h2v6h-2V7z', class: 'text-warning' },
  offline: { path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z', class: 'text-danger' },
  online: { path: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z', class: 'text-success' },
};

const getIcon = (type) => {
  return iconMap[type] || iconMap.alert;
};
</script>

<template>
  <div class="card h-100">
    <div class="card-header pb-0">
      <h6>{{ title }}</h6>
    </div>
    <div class="card-body p-3">
      <ul class="list-group list-group-flush" v-if="props.items.length">
        <li v-for="(item, index) in props.items" :key="index" class="list-group-item border-0 d-flex justify-content-between ps-0 mb-2 border-radius-lg">
          <div class="d-flex align-items-center">
            <div class="icon icon-sm icon-shape text-center me-3" :class="getIcon(item.type).class.replace('text-', 'bg-light-')">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor" :class="getIcon(item.type).class">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path :d="getIcon(item.type).path"/>
              </svg>
            </div>
            <div class="d-flex flex-column">
              <h6 class="mb-1 text-dark text-sm">{{ item.title }}</h6>
              <span class="text-xs">{{ item.description }}</span>
            </div>
          </div>
          <div class="d-flex align-items-center text-gradient text-sm font-weight-bold">
            {{ item.time }}
          </div>
        </li>
      </ul>
      <p v-else class="text-center text-muted py-4">No recent activity.</p>
    </div>
  </div>
</template>

<style scoped>
.bg-light-warning { background-color: #fffaeb; }
.bg-light-danger { background-color: #fdeaea; }
.bg-light-success { background-color: #eaf7ed; }
.dark-version .bg-light-warning { background-color: rgba(251, 189, 8, 0.2); }
.dark-version .bg-light-danger { background-color: rgba(234, 51, 94, 0.2); }
.dark-version .bg-light-success { background-color: rgba(39, 174, 96, 0.2); }
</style>
